import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Toast } from '@shared/types'

export const useToastStore = defineStore('toast', () => {
  // State
  const toasts = ref<Toast[]>([])

  // Actions
  function addToast(toast: Omit<Toast, 'id'>) {
    const id = Date.now().toString()
    const newToast: Toast = {
      id,
      duration: 5000,
      ...toast
    }
    
    toasts.value.push(newToast)
    
    // Auto remove after duration
    if (newToast.duration && newToast.duration > 0) {
      setTimeout(() => {
        removeToast(id)
      }, newToast.duration)
    }
  }

  function removeToast(id: string) {
    const index = toasts.value.findIndex(toast => toast.id === id)
    if (index > -1) {
      toasts.value.splice(index, 1)
    }
  }

  function clearAll() {
    toasts.value = []
  }

  return {
    // State
    toasts,
    
    // Actions
    addToast,
    removeToast,
    clearAll
  }
})